module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.e31fcf1.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Roboto/Roboto-Bold.ttf
// module id = 156
// module chunks = 245 246